import { render, staticRenderFns } from "./PaiementStatus.vue?vue&type=template&id=2fb1b97e&scoped=true"
import script from "./PaiementStatus.vue?vue&type=script&lang=js"
export * from "./PaiementStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb1b97e",
  null
  
)

export default component.exports